// Author thq
// Date 2024-02-20 15:19:07

import * as model from "@/model/em/statusCollection/TpmMonitorOperateModeTmoModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.TpmMonitorOperateModeTmo(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_EM_STATUSCOLLECTION_URL,
    })
    .buildStore()
